import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SecurityPipeline as StyledPipeline,
  PipelineStep,
  StepNumber,
  StepContent,
  StepTitle,
  MessageDemo,
  PipelineConnector,
  TunnelVisualization
} from './styles';

interface SecurityPipelineProps {
  activeStep: number;
  encryptionDemo: boolean;
}

const SecurityPipeline: React.FC<SecurityPipelineProps> = ({ activeStep, encryptionDemo }) => {
  const { t } = useTranslation();

  return (
    <StyledPipeline>
      <PipelineStep $active={activeStep >= 0} $completed={activeStep > 0}>
        <StepNumber></StepNumber>
        <StepContent>
          <StepTitle>{t('security.demo.step1Label')}</StepTitle>
          <MessageDemo $encrypted={false}>
            "{t('security.demo.step1')}"
          </MessageDemo>
        </StepContent>
      </PipelineStep>

      <PipelineConnector $active={activeStep >= 1} />

      <PipelineStep $active={activeStep >= 1} $completed={activeStep > 1}>
        <StepNumber></StepNumber>
        <StepContent>
          <StepTitle>{t('security.demo.step2Label')}</StepTitle>
          <MessageDemo $encrypted={true}>
            {encryptionDemo ? t('security.demo.step2') : "Aguardando..."}
          </MessageDemo>
        </StepContent>
      </PipelineStep>

      <PipelineConnector $active={activeStep >= 2} />

      <PipelineStep $active={activeStep >= 2} $completed={activeStep > 2}>
        <StepNumber></StepNumber>
        <StepContent>
          <StepTitle>{t('security.demo.step3Label')}</StepTitle>
          <TunnelVisualization $active={activeStep >= 2} />
        </StepContent>
      </PipelineStep>

      <PipelineConnector $active={activeStep >= 3} />

      <PipelineStep $active={activeStep >= 3} $completed={activeStep > 3}>
        <StepNumber></StepNumber>
        <StepContent>
          <StepTitle>{t('security.demo.step4Label')}</StepTitle>
          <MessageDemo $encrypted={false}>
            {t('security.demo.step4')}
          </MessageDemo>
        </StepContent>
      </PipelineStep>
    </StyledPipeline>
  );
};

export default SecurityPipeline;
